import { ButtonType } from '@ardoq/button';
import { ButtonWithDropdown } from '@ardoq/dropdown-menu';
import { DropdownSize } from '@ardoq/dropdown-menu-ui';
import { ExportButtonProps, ReportReaderCommands } from './types';
import { ExportIcon } from '@ardoq/icons';
import type { ExportButtonLabels } from './labels';

const DEFAULT_LABELS = {
  exportToReadableExcel: 'Export to Excel (report data only)',
  exportToReadableExcelDisabledDescription:
    'Not available for Gremlin Path reports',
  exportToExcel: 'Export to Excel (import format)',
  exportToJSON: 'Export to JSON',
  tooltip: 'Export',
} satisfies Required<ExportButtonLabels>;

const ExportButton = ({
  isDisabled,
  isExportToReadableExcelDisabled,
  commands,
  labels,
}: ExportButtonProps & {
  commands: ReportReaderCommands;
  labels?: ExportButtonLabels;
}) => {
  const mergedLabels = { ...DEFAULT_LABELS, ...labels };
  return (
    <ButtonWithDropdown
      isDisabled={isDisabled}
      alignMenuTo="left"
      dropdownSize={DropdownSize.AUTO}
      options={[
        {
          isDisabled: isExportToReadableExcelDisabled,
          label: mergedLabels.exportToReadableExcel,
          description: isExportToReadableExcelDisabled
            ? mergedLabels.exportToReadableExcelDisabledDescription
            : undefined,
          onClick: commands.exportToReadableExcel,
        },
        {
          label: mergedLabels.exportToExcel,
          onClick: commands.exportToExcel,
        },
        {
          label: mergedLabels.exportToJSON,
          onClick: commands.exportToJSON,
        },
      ]}
      data-tooltip-text={mergedLabels.tooltip}
      hideChevron
      buttonType={ButtonType.GHOST}
    >
      <ExportIcon />
    </ButtonWithDropdown>
  );
};

export { ExportButton };
